<div
    class="w-full min-h-0 flex flex-col items-center justify-start px-4 sm:px-6 flex-1 overflow-y-auto scrollbar-transparent">
    <h2
        class="text-2xl font-semibold tracking-tight text-balance text-primary sm:text-4xl md:text-5xl text-center sm:text-left use-grotesque">
        How do you want to
        <span class="bg-gradient-to-r from-primary to-brand-studio bg-clip-text text-transparent">start?</span>
    </h2>
    <p class="mx-auto mt-2 max-w-xl text-base sm:text-lg/8 text-pretty text-secondary text-center sm:text-left">Choose
        the route that fits your available time.</p>


    <div class="w-full max-w-4xl flex flex-col gap-y-2 py-6 sm:py-8">

        <div class="w-full grid grid-cols-1 sm:grid-cols-2 gap-4">

            <!-- Speedy -->
            <article (click)="onSpeedySelect()" class="group rounded-lg border border-gray-200 dark:border-white/10 bg-gray-100 dark:bg-zinc-800/50 p-4 flex flex-col gap-y-2 hover:border-teal-500 dark:hover:border-teal-400 cursor-pointer">
                <div class="shrink-0 flex flex-row w-full items-start justify-between gap-4 sm:gap-6">
                    <div
                        class="shrink-0 size-12 rounded-lg bg-gradient-to-br from-primary to-brand-studio flex items-center justify-center group-hover:size-14 transition-all duration-300">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-8 text-white">
                            <path
                                d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
                        </svg>
                    </div>

                    <span
                        class="inline-flex items-center gap-x-1.5 rounded-full bg-teal-50 dark:bg-teal-400/10 px-2 py-1 text-xs font-medium text-teal-600 dark:text-teal-400">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-4 text-teal-600 dark:text-teal-400">
                            <path d="M12 6v6l-4 2" />
                            <circle cx="12" cy="12" r="10" />
                        </svg>
                        ~3-5 min
                    </span>
                </div>

                <div>
                    <h1 class="mt-2 text-md sm:text-lg font-semibold tracking-tight text-pretty text-primary group-hover:text-teal-500 dark:group-hover:text-teal-400">Quick Brief</h1>

                    <div class="mt-2 max-w-xl text-sm sm:text-md text-secondary">
                        <p>We'll generate everything with AI. You'll be posting briefs in a few minutes.</p>
                        <ul role="list" class="mt-4 space-y-4 text-secondary">
                            <li class="flex gap-x-3">
                                <svg viewBox="0 0 6 6" aria-hidden="true" class="size-2.5 fill-teal-500 dark:fill-teal-400 mt-1">
                                    <circle r="3" cx="3" cy="3" />
                                </svg>
                                <span>AI-generated brief</span>
                            </li>
                            <li class="flex gap-x-3">
                                <svg viewBox="0 0 6 6" aria-hidden="true" class="size-2.5 fill-teal-500 dark:fill-teal-400 mt-1">
                                    <circle r="3" cx="3" cy="3" />
                                </svg>
                                <span>Trending creative angles</span>
                            </li>
                            <li class="flex gap-x-3">
                                <svg viewBox="0 0 6 6" aria-hidden="true" class="size-2.5 fill-teal-500 dark:fill-teal-400 mt-1">
                                    <circle r="3" cx="3" cy="3" />
                                </svg>
                                <span>Instant creator matches</span>
                            </li>
                        </ul>
                    </div>

                    <h1 class="mt-4 text-md sm:text-lg font-semibold tracking-tight text-pretty text-teal-600 dark:text-teal-400">Get started fast</h1>

                </div>
            </article>
            <!-- Speedy - END -->


            <!-- Skip Brief Creation -->
            <article (click)="onInDepthSelect()" class="group rounded-lg border border-gray-200 dark:border-white/10 bg-gray-100 dark:bg-zinc-800/50 p-4 flex flex-col gap-y-2 hover:border-fuchsia-500 dark:hover:border-fuchsia-400 cursor-pointer">
                <div class="shrink-0 flex flex-row w-full items-start justify-between gap-4 sm:gap-6">
                    <div
                        class="shrink-0 size-12 rounded-lg bg-gradient-to-br from-fuchsia-600 to-teal-400 flex items-center justify-center group-hover:size-14 transition-all duration-300">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-8 text-white">
                            <path d="M5 12h14" />
                            <path d="m12 19 7-7-7-7" />
                        </svg>
                    </div>

                    <span
                        class="inline-flex items-center gap-x-1.5 rounded-full bg-fuchsia-50 dark:bg-fuchsia-400/10 px-2 py-1 text-xs font-medium text-fuchsia-600 dark:text-fuchsia-400">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-4 text-fuchsia-600 dark:text-fuchsia-400">
                            <path d="M12 6v6l-4 2" />
                            <circle cx="12" cy="12" r="10" />
                        </svg>
                        Instant
                    </span>
                </div>


                <div>
                    <h1 class="mt-2 text-md sm:text-lg font-semibold tracking-tight text-pretty text-primary group-hover:text-fuchsia-500 dark:group-hover:text-fuchsia-400">Skip Brief Creation</h1>

                    <div class="mt-2 max-w-xl text-sm sm:text-md text-secondary">
                        <p>Jump straight into the platform and explore all features. Create briefs later when you're ready.</p>
                        <ul role="list" class="mt-4 space-y-4 text-secondary">
                            <li class="flex gap-x-3">
                                <svg viewBox="0 0 6 6" aria-hidden="true" class="size-2.5 fill-fuchsia-500 dark:fill-fuchsia-400 mt-1">
                                    <circle r="3" cx="3" cy="3" />
                                </svg>
                                <span>Explore the platform</span>
                            </li>
                            <li class="flex gap-x-3">
                                <svg viewBox="0 0 6 6" aria-hidden="true" class="size-2.5 fill-fuchsia-500 dark:fill-fuchsia-400 mt-1">
                                    <circle r="3" cx="3" cy="3" />
                                </svg>
                                <span>Browse creators & features</span>
                            </li>
                            <li class="flex gap-x-3">
                                <svg viewBox="0 0 6 6" aria-hidden="true" class="size-2.5 fill-fuchsia-500 dark:fill-fuchsia-400 mt-1">
                                    <circle r="3" cx="3" cy="3" />
                                </svg>
                                <span>Create briefs anytime</span>
                            </li>
                        </ul>

                    </div>
                </div>

                <h1 class="mt-4 text-md sm:text-lg font-semibold tracking-tight text-pretty text-fuchsia-600 dark:text-fuchsia-400">Explore now</h1>

            </article>
            <!-- In-Depth - END -->
        </div>

        <div class="mt-6 mx-auto text-secondary text-center text-sm">
            <p>Don't worry, you can always edit everything later.</p>
        </div>

    </div>
</div>